import { graphQLPost } from '../utilities';
import { IForecast, IForecastHistory, IForecastOverview } from '../types/types';

export default class Forecast {
    static async getForecastOverviews(): Promise<IForecastOverview[]> {
        try {
            const response
                = await graphQLPost(
                    `{
                        forecastOverview {
                          forecastId
                          
                          studentPrognosis
                          studentId
                          studentFirstName
                          studentLastName
                          studentSSN
                          studentProgram
                          
                          schoolUnitId
                          schoolUnitName
                          
                          unitId
                          unitName
                          
                          classId
                          className
                          
                          groupId
                          groupName
                          
                          courseId
                          courseName
                          courseDisplayName

                          teachers

                          writable
                          writableType
                        }
                      }`, {}
                );

            return response.forecastOverview as IForecastOverview[]
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av prognoser")
        }
    }

    static async setForecastPrognosis(id: number, prognosis: number): Promise<IForecast> {
        try {
            const response
                = await graphQLPost(
                    `mutation SetForecast($forecast: ForecastInputType!) {
                        setForecast(forecast: $forecast) {
                            id prognosis
                            student { id firstName lastName socialSecurityNumber }
                            user { id userName }
                            school { id name }
                            unit { id name }
                        }
                    }`, { forecast: { id, prognosis } }
                );

            return response.setForecast as IForecast;
        } catch (error) {
            console.error(error);
            throw("Fel vid sparning av prognoser...");
        }
    }

    static async getForecastHistory(id: number): Promise<IForecastHistory[]> {
        try {
            const response
                    = await graphQLPost(
                        `query GetForecastHistory($forecastId: Int) { 
                            forecastHistory(id: $forecastId) { 
                                id prognosis sysStartTime user { id userName }
                            }
                        }`,
                        { forecastId: id }
                    );

            return response.forecastHistory as IForecastHistory[];
        }
        catch(error) {
            console.error(error)
            throw("Fel vid hämtning av prognoshistorik...");
        }
    };

    static async getStudentHistory(studentId: number): Promise<IForecastHistory[]>{
        try{
            const response
                    = await graphQLPost(
                        `query GetStudentHistory($studentId: Int) {
                            studentHistory(studentId: $studentId) {
                                id sysStartTime grade prognosis sysEndTime schoolYear courseId
                                                forecast{
                                  course {
                                    displayName name
                                    courseInstance {
                                        endDate startDate
                                      }
                                  } 
                                }
                                user { userName }
                            } 
                        }`,
                        { studentId: studentId}
                    );
            return response.studentHistory as IForecastHistory[];
        }
        catch(error) {
            console.error(error)
            throw("Fel vid hämtning av studentens prognoshistorik...");
        }
    }
}